import React from 'react'
// const override = css`
//   display: block;
//   margin: 0 auto;
//   border-color: red;
// `;

const Spinner = () => {
  // let [loading, setLoading] = useState(true);
  // let [color, setColor] = useState('red');

  return (
    <>
      <div className="spinner-loader">
        <div className="loader"></div>
      </div>
    </>
  )
}

export default Spinner
